import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import { GrCheckbox } from "react-icons/gr";
import brandLogo from "../../assets/logo/brandLogo.png";
import backGroundImage from '../../assets/home_background.jpg'
import { Link, NavLink, useLocation } from "react-router-dom";
import Footer from "../../components/Footer";
import { BsCheck } from "react-icons/bs";
import { useDispatch } from "react-redux";
import {
  updateUserDetailhide,
  GetUserDetail,
} from "../../api/User/Auth/welcomeApi";
import {
  clearClientData,
  selectedClientData,
} from "../../Redux/Reducer/ClientDataReducer";
import { updateUserDetail } from "../../Redux/Reducer/UserDetailsReducer";
import logoutIcon from "../../assets/icon/power-off-solid.svg";
import LogoutModal from "../../components/common/Modal/LogoutModal";
import { Button, NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import Fontstyling, {
  clientListDrpDwnStyles,
} from "../../components/common/comman";
import { adminType } from "../../Utils/constants";
import { Icon } from "@iconify/react";
import ClientList from "../../components/common/ClientList";
import {
  AcceptTermCondition,
  GetClientDetailData,
} from "../../api/Admin/clientAccessApi";

const Welcome = ({ navigate }) => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [checkbox, setCheckbox] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [userData, setUserData] = useState({});
  const [selectedClientvalue, setSelectedClientValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [adminDropdown, setAdminDropdown] = useState(false);

  useEffect(() => {
    if (!state?.email) {
      navigate("/");
    } else {
      if (state?.role === "Client") {
        GetClientDetailData(state?.email).then((res) => {
          dispatch(updateUserDetail(res.data));
          setUserData(res.data);
        });
      } else {
        GetUserDetaildata();
      }
    }
  }, []);

  const GetUserDetaildata = async () => {
    let payload = {
      UD_emp_email: state?.email,
    };

    await GetUserDetail(payload)
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setUserData(res.data);
          dispatch(updateUserDetail(res.data));
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/");
        }
      });
  };

  const updateUserhidedata = async () => {
    let payload = {
      UD_id: userData.UD_id,
      UD_is_hide_welcome_msg: checkbox,
    };
    await updateUserDetailhide(payload)
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          // console.log("success");
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const handleNavigation = () => {
    if (userData?.UserRole === "Client") {
      if (checkbox) {
        AcceptTermCondition(userData.id, checkbox);
      }
      navigate("/report/sisense");
    } else {
      if (checkbox) {
        updateUserhidedata();
      }
      navigate("/HUBExperience/companysetup");
    }
  };

  const handleNavigationGo = () => {
    if (checkbox) {
      updateUserhidedata();
    }
    navigate("/HUBExperience/companysetup");
  };

  const handleClientChange = (option) => {
    setSelectedClientValue(option);
    if (option.value === 0) {
      dispatch(clearClientData(null));
      return;
    }
    let findedClientData = clientData.find(
      (item) => item.clientID === option.value
    );
    dispatch(selectedClientData(findedClientData));
  };

  return (
    <div
      className="vh-100 "
      // style={{ backgroundColor: "#010920", overflow: "auto" }}
      style={{ backgroundImage: `url(${backGroundImage})`,backgroundSize:"cover"}}
    >
      <LogoutModal
        show={showModal}
        setModal={setShowModal}
        navigate={navigate}
      />
      <nav
        className="navbar bg-body-tertiary  py-3 bg-white"
        style={{ borderBottom: "1px solid black" }}
      >
        <div className="container-fluid">
          <div
            onClick={() => {
              navigate("/Welcome", {
                state: {
                  email: userData.UD_emp_email,
                  name: userData.UD_emp_name,
                },
              });
            }}
            className="navbar-brand d-flex align-items-start cursor-pointer ps-1"
          >
            <img
              src={brandLogo}
              width="260"
              alt="logo"
              className="img-fluid me-2"
            />
            {/* <div className="fs-4 Gotham-Black">Infused Analytics</div> */}
          </div>
          <div className="d-flex gap-4 ">
            {userData.UserRole && userData?.UserRole === "Admin" && (
            //    <NavDropdown
            //    show={adminDropdown}
            //    title="System Admin"
            //    style={{
            //      textDecoration: "none",
            //      padding: "10px",
            //      color: "white",
            //      fontWeight: "700",
            //    }}
            //    className="primary-button px-4"
            //    // onClick={() => navigate("/admin")}
            //    onMouseEnter={(e) => {
            //      setAdminDropdown(true);
            //    }}
            //    onMouseLeave={() => {
            //      setAdminDropdown(false);
            //    }}
            //    id="nav-dropdown"
            //  >
            //    {" "}
            //    {adminType.map((el, index) => (
            //      <NavDropdown.Item
            //        as={Link}
            //        className="d-flex align-items-center gap-3 py-2 text-decoration-none"
            //        to={el.path}
            //        style={
            //          location.pathname.includes(`${el.path}`)
            //            ? {
            //                backgroundColor: "#00aeef",
            //                color: "white",
            //                textDecoration: "none",
            //              }
            //            : {}
            //        }
            //        onClick={() => setAdminDropdown(false)}
            //      >
            //        <span>
            //          <Icon icon={el.icon} width={24} height={28} />
            //        </span>
            //        <div
            //          style={{
            //            ...Fontstyling.sidebarheading,
            //            color:
            //              location.pathname.includes(`${el.path}`) &&
            //              "white",
            //            letterSpacing: "0.1px",
            //          }}
            //        >
            //          {el.title}
            //        </div>
            //      </NavDropdown.Item>
            //    ))}
            //  </NavDropdown>
             <NavLink
             to={"/admin"}
             style={{
                   textDecoration: "none",
                   padding: "10px",
                   color: "white",
                   fontWeight: "700",
                 }}
             className="primary-button px-4"
           >
             {"Admin"}
           </NavLink>
            )}
            <OverlayTrigger
              placement={"bottom"}
              trigger={"hover"}
              overlay={<Tooltip>Log Out</Tooltip>}
            >
              <Button className="p-2 bg-transparent border-0">
                <img
                  src={logoutIcon}
                  width="20"
                  alt="logout icon"
                  className=""
                  onClick={() => setShowModal(true)}
                />
              </Button>
            </OverlayTrigger>
          </div>
        </div>
      </nav>

      <div className="p-0">
        <h2
          class="text-white text-start mb-5 mt-5"
          style={{
            marginLeft: "10px",
            fontSize: "24px",
            fontWeight: "700",
            fontFamily: "Arial",
          }}
        >
          Welcome {state?.name} !
        </h2>
        <div class="row  justify-content-start">
          {userData?.UserRole ? (
            <div className="col-md-6 col-xs-12">
              <div style={{ marginLeft: "30px", marginBottom: "15px" }}>
                {!userData?.UD_is_hide_welcome_msg &&
                  !userData?.isAcceptTermCondition && (
                    <>
                      <p
                        class="text-white text-capitalize "
                        style={{
                          fontSize: "14.66px",
                          fontFamily: "Arial",
                          letterSpacing: "0.5px",
                        }}
                      >
                        HUB International Limited is pleased to present HUB
                        Infused Analytics (IA)! IA is North America’s leading
                        health analytics system that brings AI and machine
                        learning to big data in healthcare.{" "}
                      </p>
                      <p
                        class="text-white text-capitalize text-start"
                        style={{
                          fontSize: "14.66px",
                          fontFamily: "Arial",
                          letterSpacing: "0.5px",
                        }}
                      >
                        The IA platform is a collaboration between renown
                        institutes of health, including John’s Hopkins, MIT, and
                        U of Washington, and the leading magic quadrant power
                        from Sisense.
                      </p>
                      <p
                        class="text-white text-capitalize  text-start"
                        style={{
                          fontSize: "14.66px",
                          fontFamily: "Arial",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Combined with HUB’s national reference database of over
                        23M patients and 4.4T medical and pharmacy records, IA
                        can predict future health care utilization, chronicity
                        and acuity and prognosis of large claimants.
                      </p>

                      <div
                        style={{ display: "flex", marginBottom: "10px" }}
                        onClick={() => setCheckbox(!checkbox)}
                      >
                        <GrCheckbox
                          className="bg-white"
                          style={{ position: "relitive" }}
                        />
                        {checkbox && (
                          <BsCheck style={{ position: "absolute" }} />
                        )}
                        <div>
                          <p
                            class="text-white text-capitalize  text-start"
                            style={{
                              fontSize: "10.66px",
                              fontFamily: "Arial",
                              marginLeft: "10px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Hide this message after sign-in
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                <p
                  class="text-white text-capitalize  text-start"
                  style={{
                    fontSize: "14.66px",
                    fontFamily: "Arial",
                    letterSpacing: "0.5px",
                  }}
                >
                  To set up, modify, or request assistance, please enter the
                  main IA portal below.
                </p>
                <button
                  type="button"
                  class="btn bg-white text-capitalize text-black justify-content-end d-block"
                  style={{ fontWeight: "600", fontSize: "16px" }}
                  onClick={() => handleNavigation()}
                >
                  main portal
                </button>
              </div>

              {state?.role !== "Client" && (
                <>
                  <p
                    class="text-white text-capitalize  text-start"
                    style={{
                      fontSize: "14.66px",
                      fontFamily: "Arial",
                      marginLeft: "30px",
                      letterSpacing: "0.5px",
                    }}
                  >
                    To log into your Fusion, please select the client or
                    prospect name from the dropdown menu below.
                  </p>
                  <div
                    className="d-flex justify-content-start"
                    style={{ marginLeft: "30px" }}
                  >
                    <div className="w-50">
                      <ClientList
                        clientData={clientData}
                        setClientData={setClientData}
                        customStyles={{
                          ...clientListDrpDwnStyles,
                          control: (base) => ({
                            ...base,
                            ...Fontstyling.primaryparagraph,
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid black",
                            width: "100%",
                            maxHeight: "35px",
                            height: "35px",
                            textAlign: "left",
                          }),
                        }}
                        handleClientChange={handleClientChange}
                        selectedClientvalue={selectedClientvalue}
                        setSelectedClientValue={setSelectedClientValue}
                      />
                    </div>
                    <button
                      class="btn bg-white text-capitalize text-black"
                      style={{
                        padding: "0px 30px",
                        fontWeight: "600",
                        fontSize: "16px",
                        marginLeft: "20px",
                      }}
                      onClick={() => handleNavigationGo()}
                      disabled={selectedClientvalue?.value > 0 ? false : true}
                    >
                      go
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="col-md-6 col-xs-12"></div>
          )}
          {/* <div className="col-md-6 col-xs-12 d-md-block d-none">
            <img
              src={require("../../assets/welcome.png")}
              className={styles.mainimage}
            />
          </div> */}
        </div>

        <div className="d-none d-lg-block fixed-bottom">
          <p className="d-flex ps-2 text-white">
            <Footer />
          </p>
        </div>
        <div className="d-block d-lg-none" style={{ marginTop: "50px" }}>
          <p className="d-flex ps-2 text-white">
            <Footer />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
